"use client"
import React from 'react';

const ComponentName = () => {
        
    return (
          <div>
    

      <section className="pb-8 bg-white sm:pb-12 lg:pb-12">
        
        <div className="pt-8 overflow-hidden sm:pt-12 lg:relative lg:py-40">
          
          <div className="max-w-md px-4 mx-auto sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24">
            <div className="lg:mt-16">
              <div className="mx-auto text-center sm:max-w-lg lg:max-w-xl lg:text-left lg:mx-0">
                <h1
                  className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl xl:text-7xl sm:tracking-tight">
                  Affordable Looker Studio Reporting
                </h1>
                <p className="mt-6 text-lg leading-7 text-gray-700 lg:leading-8 lg:text-xl">
                 We connect any platform, fix your tracking, and provide ongoing support - all for just <strong>$25 per source</strong>.
                </p>
              </div>

              <div className="pt-8 flex flex-col sm:inline-flex sm:flex-row sm:space-x-4 items-center w-full sm:w-auto">
                        <div className="flex flex-col sm:flex-row items-center gap-10">
                            
                            <div
                                className="relative group mb-4 sm:mb-0"
                            >
                                <div
                                    className="absolute duration-1000 rotate-180 transitional-all opacity-70 -inset-px rounded-xl blur-lg filter group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200"
                                    style={{ background: "linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)" }}
                                ></div>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const ctaSection = document.querySelector('section[id="cta"]');
                                        ctaSection?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                    className="relative inline-flex items-center justify-center py-3.5 text-base font-bold text-white transition-all duration-200 bg-blue-600 border border-transparent px-9 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 font-pj hover:bg-opacity-90 rounded-xl"
                                >
                                    Get Started
                                </button>
                            </div>
                        
                        </div>
                    </div>
            </div>
          </div>

          <div className="sm:mx-auto sm:max-w-3xl sm:px-6">
            <div className="py-12 mt-6 sm:relative sm:mt-12 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
              <div className="relative pl-10 -mr-40 sm:max-w-3xl lg:max-w-none lg:h-full lg:pl-24">
                <img
                  className="w-full shadow-2xl rounded-xl  lg:rounded-2xl ring-[24px] ring-blue-100 lg:h-full lg:w-auto lg:max-w-none"
                  src="/images/dashboard.jpeg" alt="dashboard-mockup">
                    </img>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    )
}
export default ComponentName;